import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const CTASection = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-amber-50 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-200/30 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-teal-200/20 rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-4xl sm:text-5xl font-serif text-stone-800 mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-lg text-stone-600 mb-10 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          <Button
            onClick={() => onNavigate('contact')}
            size="lg"
            className="bg-stone-900 hover:bg-stone-800 text-white px-10 py-6 text-base font-medium shadow-lg hover:shadow-xl transition-all duration-300 group"
          >
            {t('cta.button')}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </motion.div>
      </div>
    </section>
  );
};
